{
  "AwsRegion": "us-west-2",
  "DeployedStage": "root",
  "UserPoolId": "us-west-2_OpUMA0GtR",
  "ReactAppClientId": "3mjujjo8g3ib7biaim635glf18",
  "IdentityPoolId": "us-west-2:24138712-c3de-4cbe-ab31-6733e24f37e2",
  "IotEndPoint": "a14dhvgcv3amdg-ats.iot.us-west-2.amazonaws.com",
  "WedgeConsoleS3BucketName": "rootconsole",
  "Url": "https://root.wedgeapi.com/",
  "EndPointVersion": 1
}
